/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaDto } from '../../models/media-dto';

export interface UploadStoreReviewMedia$Params {
      body: {

/**
 * Image file. Allowed formats: jpg, jpeg, png, webp, svg, tiff, gif
 */
'file': Blob;
}
}

export function uploadStoreReviewMedia(http: HttpClient, rootUrl: string, params: UploadStoreReviewMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaDto>> {
  const rb = new RequestBuilder(rootUrl, uploadStoreReviewMedia.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaDto>;
    })
  );
}

uploadStoreReviewMedia.PATH = '/api/v1/store-reviews/media';
